import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClassActuality } from 'src/app/model/enums/class-actuality';
import { LotteryService } from 'src/app/services';
import { CountdownComponent } from '../countdown.component/countdown.component';

@Component({
  selector: 'app-countdown-sale-stop',
  templateUrl: 'countdown-sale-stop.component.html',
  styleUrls: ['./countdown-sale-stop.component.scss'],
})
export class CountdownSaleStopComponent implements OnChanges {
  @ViewChild('countdown', { static: true }) countDown: CountdownComponent;

  @Input('isBsWithoutGapfund') isBsWithoutGapfund: boolean = false;
  @Input('counterHeading') remove: boolean;
  @Input('addPadding') addPadding: boolean;
  @Input('showSeconds') showSeconds: boolean;
  @Input('showAllCountdownBlocks') showAllCountdownBlocks: boolean;
  @Input('showHeadings') showHeadings: boolean;
  @Input('useAlternate') useAlternate: boolean;
  @Input('makeFlex') makeFlex: boolean;
  @Input('yellowTiles') yellowTiles: boolean;
  @Input('showNextBSSaleStopDate') showNextBSSaleStopDate: boolean;

  public time: Date;
  private saleStopSubscription: Subscription;

  constructor(private lotteryService: LotteryService) {
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const inputChanges = changes['showNextBSSaleStopDate'];
    if(inputChanges)
    {
      this.setTime();
    }
  }

  private setTime(): void {
    this.saleStopSubscription?.unsubscribe();
    // BS uden gapfund → Current (1), BS med gapfund afvist → Next (4)
    const determinedClass = (this.showNextBSSaleStopDate && !this.isBsWithoutGapfund) 
    ? ClassActuality.Next 
    : ClassActuality.Current;
    this.saleStopSubscription = this.lotteryService.getSaleStop(determinedClass).subscribe((result) => {
      const seconds = parseInt(result.Seconds, 10) || 0;
      const minutes = parseInt(result.Minutes, 10) || 0;
      const hours = parseInt(result.Hours, 10) || 0;
      const days = parseInt(result.Days, 10) || 0;

      const x = new Date();
      x.setDate(x.getDate() + days);
      x.setHours(x.getHours() + hours);
      x.setMinutes(x.getMinutes() + minutes);
      x.setSeconds(x.getSeconds() + seconds);

      this.time = x;
    });
  }
}
